import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const HeartBroken = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.032}
      d="M12.004 7.847 9.75 10.25l3.75 2.25-3 3 2.25 1.5m3.57-12a4.77 4.77 0 0 0-2.6.775A4.6 4.6 0 0 0 12 7.827a4.6 4.6 0 0 0-1.721-2.054A4.77 4.77 0 0 0 7.674 5C5.094 5 3 7.506 3 10.024 3 15.526 10.8 20 12 20s9-4.474 9-9.976C21 7.506 18.906 5 16.32 5"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(HeartBroken) as SvgIcon;
export { ForwardRef as ReactComponent };
